import { Node } from '@tiptap/core';

/**
 * A locked, two-column header row that sits above script rows showing
 * "// AUDIO" and "// VISUAL" labels. Atom node — no editable content,
 * not selectable, not draggable. Auto-injected by templates.
 */
export const ScriptHeaderRow = Node.create({
  name: 'scriptHeaderRow',
  group: 'block',
  atom: true,
  selectable: false,
  draggable: false,

  parseHTML() {
    return [{ tag: 'div[data-type="script-header-row"]' }];
  },

  renderHTML() {
    return [
      'div',
      {
        'data-type': 'script-header-row',
        class: 'script-header-row',
        contenteditable: 'false',
      },
      ['div', { class: 'script-header-cell script-header-cell-audio' }, '// AUDIO'],
      ['div', { class: 'script-header-cell script-header-cell-visual' }, '// VISUAL'],
    ];
  },
});
